{
  "Invalid date": "Ogiltigt datum",
  "Start date is required": "Startdatum krävs",
  "End date is required": "Slutdatum krävs",
  "Name is required": "Namn krävs",
  "Name": "Namn",
  "Method": "Metod",
  "Select a method": "Välj metod",
  "open-ended": "Inte tidsbegränsad",
  "self-paced": "Egen takt",
  "scheduled": "Schemalagd",
  "Date": "Datum",
  "Start date": "Startdatum",
  "End date": "slutdatum",
  "Location": "Plats",
  "Save new variant": "Spara ny variant",
  "Save variant": "Spara variant",
  "no-variants-warning": "Varianter kan bara läggas till för existerande kurser. När din nya kurs skapats kan du gå in på redigera-sidan och lägga till varianter.",
  "Stop editing": "Sluta redigera",
  "Edit variant": "Redigera variant",
  "Remove variant": "Ta bort variant",
  "Add variant": "Lägg till variant",
  "Enabled variant": "Aktiverad variant"
}
